import { hasFeature } from './has-feature';

export const withBrandingFeature = (brandedVariant, defautlVariant) => {
  return hasFeature('branding') ? brandedVariant : defautlVariant;
};
